import { z } from 'zod/v4';

/* -------------------------------------------------------------------------------------------------
 * schemas
 * -----------------------------------------------------------------------------------------------*/

const baseApiResponseSchema = z.object({
  status: z.string(),
  requestId: z.string(),
  datetime: z.string(),
});

type BaseApiResponse = z.infer<typeof baseApiResponseSchema>;

const errorInfosSchema = z.record(z.string(), z.array(z.string())).optional();

const baseApiErrorResponseSchema = z.object({
  status: z.string().optional(),
  error: z
    .object({
      type: z.string(),
      message: z.string().optional(),
      errorInfos: errorInfosSchema,
    })
    .optional(),
});

type BaseApiErrorResponse = z.infer<typeof baseApiErrorResponseSchema>;

/* -------------------------------------------------------------------------------------------------
 * utils
 * -----------------------------------------------------------------------------------------------*/

export { baseApiErrorResponseSchema, baseApiResponseSchema, errorInfosSchema };
export type { BaseApiErrorResponse, BaseApiResponse };
